import { makeStyles } from "tss-react/mui";
import { EDeviceType, getThemeBreakpointByDeviceType } from "@utils/getThemeBreakpointByDeviceType";

interface IParams {
    isMobile: boolean;
}

export const useStyle = makeStyles<IParams>()((theme, { isMobile }) => ({
    container: {
        backgroundColor: "white",
        minHeight: "600px",
        padding: isMobile ? theme.spacing(2) : theme.spacing(4),
    },
    contentWrapper: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        maxWidth: 1298,
        margin: "0 auto",
        gap: theme.spacing(4),
    },
    mainTitle: {
        color: theme.palette.primary.main,
        margin: isMobile ? theme.spacing(4, 0, 0, 0) : theme.spacing(4, 0, 4, 0),
    },
    sectionsWrapper: {
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        width: "100%",
        marginTop: theme.spacing(2),
        gap: isMobile ? theme.spacing(2) : theme.spacing(5),
    },
    section: {
        flex: "1 1 50%",
        display: "flex",
        flexDirection: "column",
        paddingBottom: theme.spacing(2),
        [theme.breakpoints.down("md")]: {
            flex: "1 1 100%",
        },
    },
    divider: {
        height: "auto",
        alignSelf: "stretch",
        minHeight: "100%",
    },
    sectionTitle: {
        color: theme.palette.secondary.main,
        paddingTop: theme.spacing(5),
    },
    card: {
        backgroundColor: theme.palette.background.dark,
        borderRadius: theme.shape.borderRadius,
        boxShadow: "none",
        marginTop: theme.spacing(2),
        position: "relative",
        overflow: "hidden",
        width: "100%",
    },
    cardContentWrapper: {
        // Override the padding of the MUI CardContent to 0
        padding: "0 !important",
        "&:last-child": {
            paddingBottom: "0 !important",
        },
    },
    cardContent: {
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        alignItems: "center",
        gap: theme.spacing(1),
    },
    image: {
        height: 162,
        objectFit: "contain",
        flexShrink: 0,
    },
    textContainer: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(1),
        padding: theme.spacing(2),
        "& .MuiTypography-root": {
            textAlign: isMobile ? "center" : "left",
        },
    },
    textContainerCentered: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(1),
        flex: 1,
        alignItems: "center",
        padding: theme.spacing(2),
        width: "100%",
    },
    mobileCardTextContainer: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(1),
        flex: 1,
        padding: theme.spacing(2),
        width: "100%",
    },
    mobileCardFlexContainer: {
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        gap: theme.spacing(3),
        margin: "auto",
        alignItems: isMobile ? "center" : "flex-start",
        textAlign: isMobile ? "center" : "left",
    },
    mobileCardLeftStack: {
        flex: 1,
    },
    cardTitle: {
        color: theme.palette.primary.main,
        fontSize: 24,
        [getThemeBreakpointByDeviceType(theme, EDeviceType.MOBILE)]: {
            fontSize: 20,
        },
    },
    priceContainer: {
        margin: theme.spacing(1, 0),
    },
    featuresList: {
        width: "100%",
    },
}));
